import { Stack } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var CSRPaymentReturnPopUp = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data, attachmentId = _ref.attachmentId;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'Header',
            value: null,
            label: '',
            display: 'flex',
            spacing: 0,
            columnSize: 12,
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'payment return',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    },
                    sx: {
                        padding: '12px'
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: 'divider',
            variant: 'fullWidth',
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'cashMode',
            label: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    columnSize: 12,
                    borderRadius: '8px',
                    sx: {
                        border: "1px solid",
                        borderColor: '#DEE4EB',
                        bgcolor: '#F4F7FA'
                    },
                    padding: '12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Customer name',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'GrandTotal',
                            label: 'Net returnable amount',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 0
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    // padding: '2px 12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'PaymentTypeName',
                            label: 'Payment method:',
                            value: null,
                            fontWeight: 'strong',
                            fontSize: 'xl',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: 'PaymentTypeId',
                            displayExpr: 'Name',
                            valueExpr: 'PaymentTypeId',
                            placeholder: 'Cash / Online',
                            columnSize: 6
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    // padding: '2px 12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'referanceno',
                            label: 'Reference No.',
                            fontWeight: 'strong',
                            fontSize: '14px',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'refNo',
                            label: '',
                            value: '',
                            placeholder: 'Reference No',
                            columnSize: 7
                        }]
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.Button,
            name: '',
            children: 'Discard',
            columnSize: 6,
            fullWidth: true,
            color: 'secondary',
            variant: 'outlined',
            size: 'medium',
            onClick: function () {
                onClose();
            }
        }, {
            type: FormItemTypes.Button,
            name: '',
            children: 'Save',
            columnSize: 6,
            fullWidth: true,
            variant: 'contained',
            size: 'medium',
            onClick: function () { return 'submit'; }
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            borderRadius: '50px'
        },
        mode: "edit"
    }));
};
